<app-top-nav></app-top-nav>
<div class="main">
  <div class="content">
    <div class="header">
      <h2>Create a new Template</h2>
    </div>
    <div class="inputs">
      <p-dropdown [options]="types" [(ngModel)]="type" placeholder="Template Type"></p-dropdown>
      <p-dropdown [options]="languages" [(ngModel)]="language" placeholder="Language"></p-dropdown>
      <p-dropdown [options]="networkOwners" [(ngModel)]="networkOwnerId" placeholder="Network Owner"></p-dropdown>
    </div>
    <div class="buttons">
      <div class="buttons-left">
        <input type="file" class="file-input" (change)="onFileSelected($event)" accept=".docx" #fileUpload>
        <div class="file-upload">
          <p-button (onClick)="fileUpload.click()"><mat-icon>upload</mat-icon>   {{filename || "Upload File"}}</p-button>
        </div>
      </div>
      <div class="buttons-right">
        <p-button routerLink="../">Cancel</p-button>
        <p-button [disabled]="!canSave()" (onClick)="onSave()" >Save</p-button>
      </div>
    </div>
  </div>
</div>
